(function () {
	'use strict';

	angular
		.module('jcsfApp')
		.controller('projectsController', projectsController);

	projectsController.$inject = [
		'$controller',
		'$rootScope',
		'$scope',
		'events',
		'authService',
	];

	function projectsController(
		$controller,
		$rootScope,
		$scope,
		events,
		authService
	) {
		$controller('baseController', { $scope: $scope });

		var vm = this;
		vm.projects = [];
		vm.orderBy = sessionStorage.getItem('projectsOrderBy') || 'DateReceived';
		vm.orderByReverse = true;
		vm.setOrderBy = setOrderBy;
		vm.errorMessage = '';
		vm.resources = [];
		vm.rsas = [];
		vm.centers = [];
		vm.center = {};
		vm.RSAId = 0;
		vm.ProjectResource = '';
		vm.ProjectTitle = '';

		authService.fillAuthData();

		vm.userJCCCC = authService.authentication.userInfo.JCCCC;
		vm.centerId = authService.authentication.userInfo.JCCCC;

		vm.remove = deleteComponent;
		vm.changeCenter = centerChanged;
		vm.saveFireProjectVerified = saveFireProjectVerified;

		activate();

		function activate() {
			$scope.subscribe(
				events.message._GET_PROJECT_LIST_COMPLETE_,
				onGetProjectsComplete
			);
			$scope.subscribe(
				events.message._GET_PROJECT_RESOURCES_LIST_COMPLETE_,
				onGetProjectResourcesComplete
			);
			$scope.subscribe(
				events.message._GET_PROJECT_LIST_FAILED_,
				onGetProjectsFailed
			);
			$scope.subscribe(
				events.message._GET_JCCENTER_LIST_COMPLETE_,
				onGetJcCentersComplete
			);
			$scope.subscribe(
				events.message._GET_RSA_LIST_COMPLETE_,
				onGetRSAsComplete
			);
			$scope.subscribe(
				events.message._DELETE_PROJECT_COMPLETE_,
				onProjectDeleted
			);

			$scope.publish(events.message._GET_JCCENTER_LIST_, []);
			$scope.publish(events.message._GET_PROJECT_RESOURCES_LIST_, []);
		}
		function onGetProjectsComplete(results) {
			vm.projects = results;
		}
		function onGetProjectsFailed(results) {
			vm.projects = [];
			if (!results || vm.projects.length === 0) {
				vm.errorMessage = 'No Records Returned';
			}
		}

		function saveFireProjectVerified(item) {
			if (item.ProjectId > 0) {
				item.LastModifiedBy = authService.authentication.userName;
			}
			item.ProjectVerified = item.ProjectVerified;

			$scope.publish(events.message._SAVE_PROJECT_, [item]);
		}

		function centerChanged(id) {
			if (id && Number(id)) {
				$scope.publish(events.message._GET_PROJECT_LIST_, [true, id]);
				vm.centerId = id;
				vm.center = vm.centers.find(function (center) {
					return center.CenterId === vm.centerId;
				});
			} else {
				vm.center = {};
			}
		}
		function onGetProjectResourcesComplete(results) {
			vm.resources = results;
		}
		function onGetJcCentersComplete(results) {
			vm.centers = results;
			if (vm.userJCCCC !== 29) {
				vm.centerId = vm.userJCCCC;
			} else if (
				$rootScope.$stateParams.id !== null &&
				$rootScope.$stateParams.id !== undefined
			) {
				if (vm.userJCCCC !== 29) {
					vm.centerId = vm.userJCCCC;
				} else {
					vm.centerId = $rootScope.$stateParams.id;
				}
			}
			centerChanged(vm.centerId);
		}
		function onGetRSAsComplete(results) {
			vm.rsas = results;
		}
		function deleteComponent(part) {
			var confirmed = window.confirm(
				'Are you sure you want to delete ' + part.ProjectTitle + '?'
			);

			if (confirmed) {
				$scope.publish(events.message._DELETE_PROJECT_, [part.ProjectId]);
			}
		}
		function onProjectDeleted(results) {
			$scope.publish(events.message._GET_PROJECT_LIST_, [true, vm.centerId]);
			vm.center = vm.centers.find(function (center) {
				return center.CenterId === vm.centerId;
			});
		}
		/**
		 * @param {string} column
		 */
		function setOrderBy(column) {
			vm.orderByReverse = vm.orderBy === column ? !vm.orderByReverse : false;
			vm.orderBy = column;
			sessionStorage.setItem('projectsOrderBy', column);
		}
	}
})();
